import * as React from 'react';
import ToastContext from '../ToastContext';

export default function useToast() {
  const { showToast, hideToast } = React.useContext(ToastContext);
  return { showToast, hideToast };
}
